import { DutyPage } from '../AttendancePage/DutyPage';

/**
 * 담당자 — 통합설정 › 조직 (2026-08-30 · 판 B1).
 *
 * ## 왜 옮겼나
 *
 * ★★ 담당자 부여는 **회사 관리자의 일**이다 — 「누가 무슨 업무를 맡는가」는 회사의 뼈대이지
 *    인사 담당자가 인사 화면에서 하는 일이 아니다. 조직도·메뉴 권한을 통합설정으로 꺼낸 것과
 *    같은 이유다(자리 재정의 판 4).
 *
 * ★★ **「옮긴다」는 라우트를 옮기는 것**이다(2026-08-29 판 B 에서 배운 것) — 목록에서만 빼고
 *    화면을 그대로 두면 **이름만 옮긴 것**이 된다. 그래서 인사 트리에서 항목을 빼고 여기에 세운다.
 *
 * ★ 옛 주소(`/erp/hr/duties`)는 **살려 둔다** — 북마크·지난 안내가 가리키고 있다.
 */
export function DutySection(): JSX.Element {
  return <DutyPage />;
}

export default DutySection;
